export default __webpack_public_path__ + "static/media/womenCoatTrousers.0f0177eb.svg";